import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import { Plugin } from 'vue-fragment'

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    isOnPC () {
      return this.$vuetify.breakpoint.smAndUp
    }
  }
})

Vue.use(Plugin)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
